export class PeerSyncMessageTimeoutError extends Error {
  public static readonly Code = 'PEER_SYNC_MESSAGE_TIMEOUT_ERROR';

  public static readonly code = PeerSyncMessageTimeoutError.Code;

  constructor(message: string) {
    super(message);
    this.name = 'PeerSyncMessageTimeoutError';
  }
}
